import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

const getChildNode = (node) => {
  return Array.isArray(node?.content) ? node?.content : node?.content?.content;
};

const getMarkType = (mark) => {
  return typeof mark?.type === 'string' ? mark?.type : mark?.type?.name;
};

const isLinkMark = (mark) => {
  return getMarkType(mark) === 'link';
};

// BFS the AST and transform the variable template link.
export const traverse = function (root) {
  const nodeRoot = getChildNode(root);
  const queue = [...nodeRoot];
  let prevNode = null;

  while (queue?.length > 0) {
    const currNode = queue.shift();
    const child = getChildNode(currNode);
    if (child?.length) {
      queue.push(...child);
      continue;
    }
    // Check current node has mark and it is a link
    if (
      currNode?.marks?.length &&
      currNode?.marks.find((mark) => isLinkMark(mark))
    ) {
      const nextNode = queue[0];
      const prevHasVariable = prevNode?.text?.slice(-2)?.trim() === '{{';
      const nextHasVariable = nextNode?.text?.slice(0, 2)?.trim() === '}}';

      // check previous node last two char and next node first char is {{ and }}, then filter the link from the mark.
      if (prevHasVariable && nextHasVariable) {
        currNode.marks = currNode?.marks.filter((mark) => !isLinkMark(mark));
      }
      // Delete the mark key in current node, if it is empty and it is a text node.
      if (currNode?.type === 'text' && !currNode?.marks?.length) {
        delete currNode.marks;
      }
    }
    prevNode = currNode;
  }
  return root;
};

/**
 * How to use.
 const editor = useEditor({
    extensions: [
      StarterKit,
      Link.configure({
        linkOnPaste: false,
        openOnClick: false,
      }),
      SanitizeTemplateVariables, // use here.
    ],
  });
 */

export const SanitizeTemplateVariables = Extension.create({
  name: 'SanitizeTemplateVariables',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('SanitizeTemplateVariables'),
        props: {
          transformPasted(json) {
            try {
              return traverse(json);
            } catch (e) {
              return json;
            }
          },
        },
      }),
    ];
  },
});

export const hasEmptySurveyPlaceholder = (body) => {
  const el = document.querySelector('.editor-survey-select-container');
  if (
    (body.includes('data-survey-select') && !body.includes('surveyid')) ||
    body.includes('{{survey.link}}')
  ) {
    if (el) {
      el.classList.add('empty-survey-placeholder-error');
    }
    return true;
  } else {
    if (el) {
      el.classList.remove('empty-survey-placeholder-error');
    }
  }
  return false;
};
